import { render, staticRenderFns } from "./helloword.vue?vue&type=template&id=74f817d6&scoped=true"
import script from "./helloword.vue?vue&type=script&lang=js"
export * from "./helloword.vue?vue&type=script&lang=js"
import style0 from "./helloword.vue?vue&type=style&index=0&id=74f817d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f817d6",
  null
  
)

export default component.exports